try {
    // Source: https://developer.mozilla.org/en/docs/Web/API/Element/matches
    // Public Domain
    /* eslint-disable no-undef */
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {
                        /* Do nothing */
                    }
                    return i > -1;
                };
    }
    /* eslint-enable no-undef */
}
catch (e) {
    // We must be in node. do nothing
}
function warn(message) {
    console.warn("[RM-HTML-PDF] " + message);
}
function textWarning(parentElem) {
    warn("<" + parentElem.tagName.toLowerCase() + "> cannot contain text.");
}
function childWarning(parentElem, childElem) {
    warn("<" + childElem.tagName.toLowerCase() + "> cannot be a child of <" + parentElem.tagName.toLowerCase() + ">");
}
var times = {};
function trackTime(label, fn) {
    var s = new Date().getTime();
    var r = fn();
    times[label] = (times[label] || 0) + new Date().getTime() - s;
    return r;
}
function logTimes() {
    Object.keys(times).forEach(function (label) {
        // eslint-disable-next-line no-console
        console.log("".concat(label, ": ").concat(times[label]));
    });
}
module.exports = {
    warn: warn,
    textWarning: textWarning,
    childWarning: childWarning,
    trackTime: trackTime,
    logTimes: logTimes
};
//# sourceMappingURL=module.js.map